import Cookies from 'universal-cookie';
import { TOURLANE_ID_COOKIE_NAME, VISIT_ID_COOKIE_NAME } from './cookies';
export var CUSTOMER_UUID_COOKIE_NAME = 'customer_uuid';
export var getSchema = function getSchema(identifier, version) {
  if (version === void 0) {
    version = '1-0-0';
  }

  return "iglu:com.tourlane/" + identifier + "/jsonschema/" + version;
}; // type is set to undefined to handle getCustomerContext() sending undefined

export var filterFalsy = function filterFalsy(arr) {
  return arr.filter(Boolean);
};
export var Schema = {
  TOURLANE_META_ENTITY: getSchema('tourlane_meta_entity', '1-0-1'),
  TOURLANE_CUSTOMER_ENTITY: getSchema('tourlane_customer_entity', '1-0-0'),
  EXPERIMENT_ENTITY: getSchema('experiment_entity', '1-0-1'),
  TRAVEL_REQUEST_ENTITY: getSchema('travel_request_entity', '1-0-0'),
  LANDING_PAGE_ENTITY: getSchema('landing_page', '1-0-0'),
  ID_MAP_EVENT: getSchema('id_map', '1-0-0'),
  CLICK_EVENT: getSchema('click', '1-0-0'),
  HOVER_EVENT: getSchema('hover', '1-0-0'),
  COMPONENT_ENTITY: getSchema('component', '1-0-0'),
  COMPONENT_EVENT: getSchema('component_event', '2-0-0'),
  QUALIFICATION_SIGNUP_EVENT: getSchema('qualification_signup', '1-0-1'),
  QUALIFICATION_QUESTIONNAIRE_COMPLETE_EVENT: getSchema('qualification_questionnaire_complete', '1-0-0'),
  VOUCHER_ENTITY: getSchema('voucher', '1-0-0'),
  VOUCHER_VALIDATE_EVENT: getSchema('voucher_validate', '1-0-0'),
  QUALIFICATION_ANSWER_ENTITY: getSchema('qualification_answer', '1-0-0'),
  QUALIFICATION_QUESTIONNAIRE_FLOW_EVENT: getSchema('qualification_questionnaire_flow', '2-0-1'),
  PHONE_SCHEDULE_EVENT: getSchema('phone_schedule', '1-0-1'),
  UNSUBSCRIBE_EVENT: getSchema('unsubscribe_feedback_submit', '1-0-0'),
  EXPERIMENT_DISQUALIFICATION_ENTITY: getSchema('experiment_disqualification_entity', '1-0-0'),
  CONVERSION_EVENT: getSchema('conversion', '1-0-0'),
  OFFER_PREVIEW_ENTITY: getSchema('offer_preview_entity', '1-0-0'),
  OFFER_PREVIEW_MESSAGE_ENTITY: getSchema('offer_preview_message_entity', '1-0-0'),
  TRIP_PLANING_ENTITY: getSchema('trip_planing_entity', '3-0-0'),
  TRIP_USER_ENTITY: getSchema('trip_user_entity', '2-0-0'),
  ANYTHING_A_ENTITY: 'iglu:com.snowplowanalytics.iglu/anything-a/jsonschema/1-0-0',
  SEARCH_PARAM_ENTITY: getSchema("search_param_entity", "1-0-0")
};
export var EVENT_TYPE;

(function (EVENT_TYPE) {
  EVENT_TYPE["SELF_DESCRIBING_EVENT"] = "trackSelfDescribingEvent";
})(EVENT_TYPE || (EVENT_TYPE = {}));

export var PageType = {
  // (albatross)
  HOME_PAGE: 'home_page',
  JOURNAL: 'journal',
  // (morpheus / mantis)
  LANDING_PAGE: 'landing_page',
  // SEO (buffalo/phoenix)
  CATEGORY_ROOT: 'category_root',
  DESTINATION: 'destination',
  ACTIVITY: 'activity',
  TRIP_TYPES: 'trip_types',
  ACTIVITY_DESTINATION: 'activity_destination',
  TRIP_TYPE: 'trip_type',
  TRIP_TYPE_DESTINATION: 'trip_type_destination',
  OFFER: 'offer',
  CAMPAIGN_MVP: 'campaign_mvp',
  // (career)
  CAREER: 'career',
  BECOME_A_TRAVEL_EXPERT: 'become_a_travel_expert',
  PRESS: 'press',
  ONLINE_TRAVEL_AGENCY: 'online_travel_agency',
  IMPRINT: 'imprint',
  DATA_PROTECTION: 'data_protection',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  TRAVEL_TIPS: 'travel_tips',
  UNSUBSCRIBE: 'unsubscribe',
  // (owl & peacock)
  SECOND_BRAND_HOME: 'second_brand_home',
  PAGE_404: '404'
};
export var Category;

(function (Category) {
  Category["BUTTON"] = "button";
  Category["FORM"] = "form";
  Category["COMPONENT"] = "component";
  Category["QUESTION"] = "question";
  Category["PROGRESS"] = "progress";
})(Category || (Category = {}));

export var Action;

(function (Action) {
  Action["VIEW"] = "view";
  Action["CLICK"] = "click";
  Action["CHANGE"] = "change";
  Action["SUBMIT"] = "submit";
  Action["SUBMIT_SUCCEEDED"] = "submit_succeeded";
  Action["HOVER"] = "hover";
  Action["PROGRESS"] = "progress";
  Action["SCROLL"] = "scroll";
  Action["CLICK_ON_TOP_CTA"] = "click on top CTA";
})(Action || (Action = {}));

export var Label;

(function (Label) {
  Label["LEAD_CREATED"] = "lead_created";
  Label["FIRST_FORM_SUBMITTED"] = "first_form_submitted";
  Label["FIRST_FORM_VIEWED"] = "first_form_viewed";
  Label["FIRST_FORM_VIEWED_SEVEN_SECONDS"] = "first_form_viewed_seven_seconds";
  Label["EXPERT_FORM_SUBMITTED"] = "expert_form_submitted";
  Label["VOUCHER_MODAL_VIEWED"] = "voucher_modal_viewed";
  Label["VOUCHER_CODE_COPIED"] = "voucher_code_copied";
  Label["QUESTION_ANSWERED"] = "question_answered";
  Label["QUESTION_VIEWED"] = "question_viewed";
  Label["OFFER_SELECTED"] = "offer_selected";
  Label["OFFER_VIEWED"] = "offer_viewed";
  Label["OFFERS_AVAILABLE"] = "offers_available";
  Label["QUESTIONNAIRE_FINISHED"] = "questionnaire_finished";
  Label["PHONE_FORM_VIEWED"] = "phone_form_viewed";
  Label["SPINNER_VIEWED"] = "spinner_viewed";
  Label["SEARCH_BUTTON_CLICKED"] = "search_button_clicked";
  Label["CHAT_BUTTON_CLICKED"] = "chat_button_clicked";
  Label["CALL_NOW_BUTTON_CLICKED"] = "call_now_button_clicked";
  Label["INBOUND_CALL_US_UK"] = "inbound_call_us_uk";
  Label["OFFER_PREVIEW_MODAL_OPEN"] = "offer_preview_modal_open";
  Label["OFFER_PREVIEW_REGISTRATION_FORM_VISIBLE"] = "offer_preview_registration_form_visible";
  Label["MAP_CLICKED"] = "op_map";
  Label["POI_CLICKED"] = "op_poi";
  Label["ACTIVITIES_CLICKED"] = "op_activities";
  Label["TRAVELTIPS_CLICKED"] = "op_traveltips";
  Label["DAY_CLICKED"] = "op_day";
  Label["AREA_CLICKED"] = "op_area";
})(Label || (Label = {}));

export var COOKIE_MAX_AGE = 900000;
export var getCookie = function getCookie(name) {
  return new Cookies().getAll()[name];
};
export var setCookie = function setCookie(cookieName, cookieValue) {
  var cookie = new Cookies();
  cookie.set(cookieName, cookieValue, {
    maxAge: COOKIE_MAX_AGE,
    httpOnly: false
  });
};
/**
 * Generate data for Tourlane Meta Context object for Snowplow
 */

export var getTourlaneMetaContext = function getTourlaneMetaContext(pageType, destination) {
  if (destination === void 0) {
    destination = '';
  }

  return {
    schema: Schema.TOURLANE_META_ENTITY,
    data: {
      visit_id: getCookie(VISIT_ID_COOKIE_NAME) || '',
      page_type: pageType || '',
      destination: destination
    }
  };
};
export var getCustomerContext = function getCustomerContext() {
  var customerId = getCookie(CUSTOMER_UUID_COOKIE_NAME);
  return customerId && {
    schema: Schema.TOURLANE_CUSTOMER_ENTITY,
    data: {
      customer_uuid: customerId
    }
  };
};

/**
 * Generate a list of objects for each truthy feature flag of EXPERIMENT_ENTITY schema
 */
export var getExperimentContexts = function getExperimentContexts(featureFlags) {
  if (featureFlags === void 0) {
    featureFlags = {};
  }

  return Object.keys(featureFlags).map(function (key) {
    var value = featureFlags[key];
    return {
      schema: Schema.EXPERIMENT_ENTITY,
      data: {
        variation: key,
        // Value should be a string as per EXPERIMENT_ENTITY schema
        value: String(value)
      }
    };
  });
};

var isThenable = function isThenable(input) {
  return input && typeof input.then === 'function';
};
/**
 * Define global context to be sent with every single event
 * subsequently recorded, other than pageView events. If args are promise,
 * wait for promise to resolve before setting global context.
 * All other tracking functions will wait for this promise before
 * submitting tracking data with the help of withAsyncGlobalContext.
 */


var setGlobalContext = function setGlobalContext(args) {
  var _setGC = function _setGC(_ref) {
    var featureFlags = _ref.featureFlags,
        _ref$entities = _ref.entities,
        entities = _ref$entities === void 0 ? [] : _ref$entities;
    var globalContext = filterFalsy([getCustomerContext()].concat(getExperimentContexts(featureFlags), entities));

    if (globalContext.length > 0) {
      window.snowplow('addGlobalContexts', globalContext);
    }
  };

  if (isThenable(args)) {
    window.__SP_PROMISE = args.then(_setGC);
  } else {
    _setGC(args);
  }
};

export var addToGlobalContext = function addToGlobalContext(entities) {
  window.snowplow('addGlobalContexts', entities);
};
/**
 * Set user ID from the Cookie and activate PP tracking
 * @param args will be set to GlobalContext
 * @param minimumVisitLength
 * @param heartbeatDelay
 */

export var setup = function setup(args, minimumVisitLength, heartbeatDelay) {
  if (minimumVisitLength === void 0) {
    minimumVisitLength = 30;
  }

  if (heartbeatDelay === void 0) {
    heartbeatDelay = 10;
  }

  window.snowplow('setUserIdFromCookie', TOURLANE_ID_COOKIE_NAME);
  window.snowplow('enableActivityTracking', {
    minimumVisitLength: minimumVisitLength,
    heartbeatDelay: heartbeatDelay
  });
  if (args) setGlobalContext(args);
};
export var withAsyncGlobalContext = function withAsyncGlobalContext(trackingFn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (window.__SP_PROMISE) {
      window.__SP_PROMISE.then(function () {
        return trackingFn.apply(void 0, args);
      });
    } else {
      trackingFn.apply(void 0, args);
    }
  };
};
/**
 * Tracking Page View
 * Generic snowplow trackPageView wrapped by withAsyncGlobalContext
 */

export var trackPageView = withAsyncGlobalContext(function (_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      pageType = _ref2.pageType,
      _ref2$destination = _ref2.destination,
      destination = _ref2$destination === void 0 ? '' : _ref2$destination,
      _ref2$entities = _ref2.entities,
      entities = _ref2$entities === void 0 ? [] : _ref2$entities;

  return window.snowplow('trackPageView', {
    context: filterFalsy([getTourlaneMetaContext(pageType, destination)].concat(entities))
  });
});
/**
 * Tracking Struct Event
 * Generic snowplow trackStructEvent wrapped by withAsyncGlobalContext
 */

export var trackStructEvent = withAsyncGlobalContext(function (_ref3) {
  var category = _ref3.category,
      action = _ref3.action,
      label = _ref3.label,
      property = _ref3.property,
      value = _ref3.value,
      _ref3$entities = _ref3.entities,
      entities = _ref3$entities === void 0 ? [] : _ref3$entities,
      pageType = _ref3.pageType,
      _ref3$destination = _ref3.destination,
      destination = _ref3$destination === void 0 ? '' : _ref3$destination;
  return window.snowplow('trackStructEvent', {
    category: category,
    action: action,
    label: label,
    property: property,
    value: value,
    context: filterFalsy([getTourlaneMetaContext(pageType, destination)].concat(entities))
  });
});

/**
 * Tracking SelfDescribing Event
 * Generic snowplow trackSelfDescribingEvent wrapped by withAsyncGlobalContext
 */
export var trackSelfDescribingEvent = withAsyncGlobalContext(function (_ref4) {
  var destination = _ref4.destination,
      _ref4$entities = _ref4.entities,
      entities = _ref4$entities === void 0 ? [] : _ref4$entities,
      event = _ref4.event,
      pageType = _ref4.pageType;
  return window.snowplow(EVENT_TYPE.SELF_DESCRIBING_EVENT, {
    event: event,
    context: filterFalsy([getTourlaneMetaContext(pageType, destination)].concat(entities))
  });
});
export var clearGlobalContexts = function clearGlobalContexts() {
  window.snowplow('clearGlobalContexts');
};
export var removeGlobalContexts = function removeGlobalContexts(entities) {
  window.snowplow('removeGlobalContexts', entities);
};